
import { useEffect, useRef, useState } from "react"
import { gsap } from "gsap"
import FooterSection from "../../Layout/Footer"
import { useNavigate } from "react-router-dom"
export default function CookiesPolicy() {
    const heroRef = useRef(null)
    const navRef = useRef(null)
    const contentRef = useRef(null)
    const navigate = useNavigate()

    const sections = [
        { id: "intro", label: "Introduction" },

        { id: "Definition", label: "Definition of Cookies" },
        { id: "Types", label: "Types of Cookies We Use" },
        { id: "Information", label: "Information Collected Through Cookies" },
        { id: "Why", label: "Why We Use Cookies" },
        { id: "Third", label: " Third Party Tracking and Analytics" },
        { id: "Cookies", label: "Cookies and AI-Enabled Features" },
        { id: "Choices", label: "Choices and Controls" },
        { id: "AmendMent", label: "AmendMent to Cookies Practices" },

    ]
    useEffect(() => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "instant",
  });
}, []);


    const [active, setActive] = useState("intro")

    useEffect(() => {
        gsap.fromTo(heroRef.current, { opacity: 0, y: -40 }, { opacity: 1, y: 0, duration: 1 })
        gsap.fromTo(navRef.current, { opacity: 0, x: -30 }, { opacity: 1, x: 0, duration: 1, delay: 0.2 })
        gsap.fromTo(contentRef.current, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 1, delay: 0.3 })
    }, [])

    const scrollToSection = (id) => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })
        setActive(id)
    }

    return (
<>
        <div className="min-h-screen bg-[#0B0B0B] text-[#CFCFCF]">
            {/* HERO */}
            <section ref={heroRef} className="relative bg-gradient-to-br from-black via-[#140800] to-[#2a1200] py-28 border-b border-white/5">
                                <div className="max-w-7xl mx-auto absolute top-6 left-6">
                        <button onClick={() => navigate(-1)} class=" backdrop-blur-xl bg-white/10 border border-white/20 px-5 py-2.5 rounded-full text-white flex items-center gap-2 shadow-xl hover:bg-white/20 transition">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                role="img" class="iconify iconify--mdi text-lg" width="1em" height="1em"
                                viewBox="0 0 24 24">
                                <path fill="currentColor" d="M20 11v2H8l5.5 5.5l-1.42 1.42L4.16 12l7.92-7.92L13.5 5.5L8 11z"></path>
                            </svg>
                            Back
                        </button>
                    </div>
                <div className="max-w-5xl mx-auto text-center px-4">
                    <h1 className="text-4xl md:text-5xl font-bold mb-4">COOKIES POLICY</h1>
                </div>
                {/* subtle glow */}
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,106,0,0.15),transparent_60%)] pointer-events-none" />
            </section>

            {/* CONTENT */}
            <section className="max-w-7xl mx-auto px-4 py-16 grid grid-cols-1 lg:grid-cols-4 gap-8">
                {/* LEFT NAV */}
                <aside ref={navRef}>
                    <div className="bg-[#111111] rounded-2xl border border-white/5 p-4 sticky top-24">
                        <h3 className="font-semibold mb-4">Quick Navigation</h3>
                        <ul className="space-y-2">
                            {sections.map((s) => (
                                <li key={s.id}>
                                    <button
                                        onClick={() => scrollToSection(s.id)}
                                        className={`w-full text-left px-3 py-2 rounded-lg text-sm transition
                                         ${active === s.id
                                                ? "bg-[#FF6A00] text-white shadow-[0_0_30px_rgba(255,106,0,0.35)]"
                                                : "text-gray-400 hover:bg-white/5 hover:text-white"
                                            }`}
                                    >
                                        {s.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </aside>

                {/* RIGHT CONTENT */}
                <main ref={contentRef} className="lg:col-span-3">
                    <div className="bg-[#111111] rounded-2xl border border-white/5 p-8 space-y-14 text-sm leading-relaxed">

                        <Section id="intro" title="Introduction">
                            This Cookies Policy explains how Remark HR (the “Platform”), operated by
                            <span className="font-bold text-white"> Visko HR & IT LLC </span> (“Company”, “we”, “our”, or “us”), uses cookies and similar tracking
                            technologies when you access or use our website, mobile application, or related digital services.<br /><br />
                            <p className="font-normal">This Cookies Policy should be read together with our Privacy Policy and Terms and Conditions. By continuing to
                                use the Platform, you consent to the use of cookies in accordance with this Cookies Policy, subject to your
                                preferences and applicable law.</p>
                        </Section>


                        <Section id="Definition" title="1. Definition of Cookies">
                            <b>                            Cookies are small text files placed on your device (computer, smartphone, tablet, or other internet-enabled
                                device) when you visit a website or use an application. Cookies help recognise your device, store
                                preferences, enable platform functionality, enhance security, and analyse usage patterns. Cookies may
                                be:</b>
                            <ul className="list-disc pl-5 space-y-1">
                                <li>Session cookies (deleted when you close your browser), or</li>
                                <li>Persistent cookies (remain on your device for a defined period or until deleted).</li>


                            </ul>
                        </Section>

                        <Section id="Types" title="2. Types of Cookies We Use">
                            <b className="flex">2.1 <p className="font-normal">Strictly Necessary Cookies – These cookies are essential for the operation and security of the
                                Platform. Without them, core services such as login, authentication, session management, and
                                secure access may not function properly.</p></b><br />
                            <b className="flex">2.2<p className="font-normal"> Performance & Analytics Cookies – These cookies help us understand how users interact with the
                                Platform by collecting information such as pages visited, time spent, and error reports. This data is
                                used to improve platform performance, navigation, and user experience. Such cookies are currently
                                not deployed on the Platform and shall only be activated where legally permitted and subject to user
                                consent.</p></b><br />

                            <b className="flex">2.3 <p className="font-normal">Functionality Cookies – These cookies remember your preferences and choices (such as language,
                                location, and account settings) to provide a more personalised and convenient user experience. Such
                                cookies are currently not deployed on the Platform and shall only be activated where legally permitted
                                and subject to user consent.</p></b><br />
                            <b className="flex">2.4 <p className="font-normal">Targeting/Advertising Cookies – These cookies track browsing behaviour across platforms to deliver
                                relevant job recommendations, career opportunities, and promotional content. They may be placed
                                by us or trusted third-party advertising partners. Such cookies are currently not deployed on the
                                Platform and shall only be activated where legally permitted and subject to user consent.</p></b><br />
                            <b className="flex">2.5 <p className="font-normal">Third-Party Cookies – Some cookies may be placed by third-party service providers that support our
                                Platform, such as analytics providers, advertising partners, security services, or infrastructure
                                providers. We do not control third-party cookies, and their use is governed by the respective third
                                party’s privacy and cookies policies. The Company shall not be responsible for the operation, content,
                                or data practices of such third-party cookies.</p></b><br />

                        </Section>

                        <Section id="Information" title="3. Information Collected Through Cookies">
                            <b>Cookies and similar technologies used on the Platform collect limited technical and usage information
                                strictly for purposes of security, functionality, and basic analytics. Such information may include:</b>
                            <br />
                            <ul className="list-disc pl-5 space-y-1">
                                <li>IP address and general device or browser information (such as browser type, operating system,
                                    and device category);</li>
                                <li>session-related information (such as login status, session identifiers, and authentication tokens);</li>
                                <li>general usage data (such as pages viewed, features accessed, and navigation patterns);</li>
                                <li>referral information (such as the source from which the Platform was accessed).</li>
                            </ul><br />

                            <b>The Company does not use cookies to collect sensitive personal data, precise/exact geolocation data, or
                                to create detailed behavioural, cross-platform, or interest-based advertising profiles. Information collected
                                through cookies is used solely to:</b>
                            <br />
                            <ul className="list-disc pl-5 space-y-1">
                                <li>maintain Platform security and prevent unauthorised access;</li>
                                <li>manage login sessions, authentication, and core functionality;</li>
                                <li>monitor aggregated usage trends and improve Platform performance; and</li>
                                <li>enhance overall user experience in a non-intrusive manner.</li>
                            </ul>
                            <b>Such information is processed in an aggregated or limited form, retained only for as long as necessary to
                                fulfil the stated purposes, and handled in accordance with applicable data protection laws and the
                                Company’s Privacy Policy.</b>

                        </Section>

                        <Section id="Why" title="4. Why We Use Cookies">
                            <b>We use cookies and similar tracking technologies to:</b>
                            <br />
                            <ul className="list-disc pl-5 space-y-1">
                                <li>ensure Platform security and detect or prevent fraudulent or unauthorised activity;</li>
                                <li>enable essential features such as login, authentication, and navigation;</li>
                                <li>analyse traffic and usage patterns to improve functionality, performance, and reliability;</li>
                                <li>improve content relevance based on aggregated, non-profiling usage insights;</li>
                                <li>conduct aggregated analytics and research relating to hiring trends.</li>
                            </ul>
                            <b>Any marketing, advertising, or promotional cookies, if introduced in the future, shall be used only with user
                                consent and in compliance with applicable law. Where required by law, additional consent mechanisms
                                may be provided.</b>
                        </Section>

                        <Section id="Third" title="5. Third Party Tracking and Analytics">
                            The Platform may integrate with third-party analytics or performance measurement tools (such as web
                            analytics, advertising insights, or security monitoring services) to better understand Platform usage and
                            effectiveness. Such third-party service providers may collect and process information independently in
                            accordance with their own privacy and cookies policies. The Company does not control the data practices
                            of these third parties and encourages users to review their respective policies. The Company integrates
                            only with service providers that follow commercially reasonable data protection and security standards
                            consistent with applicable laws.

                        </Section>

                        <Section id="Cookies" title="6. Cookies and AI-Enabled Features">
                            Cookies and similar technologies may be used to support AI-enabled features on the Platform, including
                            recommendations, analysis, performance optimisation, and fraud detection. Such processing is
                            conducted in accordance with our Privacy Policy and does not result in automated hiring or employment
                            decisions.
                        </Section>

                        <Section id="Choices" title="7. Choices and Controls">
                            <b>You have control over how cookies are used:</b>
                            <ul className="list-disc pl-5 space-y-1">
                                <li>You may manage or block cookies through your browser or device settings.</li>
                                <li>Most browsers allow you to delete existing cookies or receive alerts when cookies are being set.</li>
                                <li>You may use opt-out mechanisms provided by third-party analytics or advertising partners.</li>
                            </ul>
                            <b>Please note that disabling certain cookies may affect the functionality and user experience of the Platform.</b>
                        </Section>

                        <Section id="AmendMent" title="8. Amendment to Cookies Practices">
                            We may update this Cookies Policy from time to time to reflect changes in technology, legal requirements,
                            or our practices. Any material changes will be communicated through the Platform or by updating this
                            Policy. Continued use of the Platform after such updates constitutes acceptance of the revised Policy.
                            If you have any queries or concerns regarding this Cookies Policy, please contact us at
                        </Section>


                    </div>
                </main>
            </section>
        </div>

                    <FooterSection /></>
    )
}

function Section({ id, title, children }) {
    return (
        <section id={id}>
            <h2 className="text-lg font-semibold mb-3 text-white">
                <span className="text-[#FF6A00] mr-2">◆</span>{title}
            </h2>
            <div className="text-gray-400">
                {children}
            </div>
        </section>
    )
}

